import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { TNavigationStackWithParams } from 'app/types';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import MeasurementFlow from "../components/activity/flow/MeasurementFlow"
import { ActivityName } from '../types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

const MeasurementFlowScreen = () => {
    const route = useRoute<RouteProp<TNavigationStackWithParams<{
        activityName: ActivityName,
        activityId: string,
        initialStep?: number,
        isRemeasurement?: boolean,
        forceReset?: boolean,
        autoStartWebSocket?: boolean
   }>, 'ActivitySubmit'>>();
    const navigation = useNavigation<NativeStackNavigationProp<TNavigationStackWithParams<undefined>>>();

    const activityName = route.params?.activityName;
    const activityId = route.params?.activityId;
    const isRemeasurement = route.params?.isRemeasurement || false;
    const forceReset = route.params?.forceReset || false;
    const autoStartWebSocket = route.params?.autoStartWebSocket || false;

    const initialStep = forceReset ? 0 : (route.params?.initialStep || 0);

    const handleGoToHome = () => {
        navigation.navigate("Homepage");
    }


    return (
        <MainLayout navigation={handleGoToHome}>
                <MeasurementFlow
                    activityName={activityName}
                    activityId={activityId}
                    initialStep={initialStep}
                    forceReset={forceReset}
                    isRemeasurement={isRemeasurement}
                    autoStartWebSocket={autoStartWebSocket}
                />
        </MainLayout>
    );
};
export default MeasurementFlowScreen;